import { render, staticRenderFns } from "./OwalListSectionHeader.vue?vue&type=template&id=27ea5709&scoped=true"
import script from "./OwalListSectionHeader.vue?vue&type=script&lang=js"
export * from "./OwalListSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./OwalListSectionHeader.vue?vue&type=style&index=0&id=27ea5709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea5709",
  null
  
)

export default component.exports